import { useStore } from './useStore';
import { reactionPackStore } from '../store';

export type UseReactionPackArg = {
  reactionSpaceId: string;
};

export function useReactionPacks({ reactionSpaceId }: UseReactionPackArg) {
  const reactionPackStoreValue = useStore(reactionPackStore);

  return {
    reactionPacks: reactionPackStoreValue[reactionSpaceId] || [],
  };
}
